import _objectWithoutProperties from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _toPropertyKey from "/usr/app/node_modules/@babel/runtime/helpers/esm/toPropertyKey.js";
import _defineProperty from "/usr/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
var _excluded = ["down_payment"],
  _excluded2 = ["down_payment"],
  _excluded3 = ["last_payment"],
  _excluded4 = ["last_payment"];
import React from "react";
var __jsx = React.createElement;
import stl from './InstallmentCalculatorView.module.css';
import { useTranslation } from "@i18n";
import Input from "@/components/UiKit/Input/Input";
import { InstallmentCalculatorProvider, useInstallmentCalculator } from "@/_MiniApps/Installment-calculator/InstallmentCalculatorContext";
import { useModal } from "@componentsShared/BottomSheet";
import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { formatNumberWithCommas, getArabicYearWord } from "@/utils/stringHelpers";
var InstallmentCalculator = function InstallmentCalculator(_ref) {
  var _state$down_payment, _state$last_payment;
  var onClose = _ref.onClose,
    carCondition = _ref.carCondition,
    onInteraction = _ref.onInteraction;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useInstallmentCalcul = useInstallmentCalculator(),
    state = _useInstallmentCalcul.state,
    setState = _useInstallmentCalcul.setState;
  var _useModal = useModal(),
    goToScreen = _useModal.goToScreen;
  var _useState = useState({}),
    errors = _useState[0],
    updateErrors = _useState[1];
  var _useState2 = useState(false),
    buttonLoading = _useState2[0],
    setButtonLoading = _useState2[1];
  var params = useParams();
  var postId = params.id.split('-').pop();
  var navigate = useNavigate();
  console.log(errors, 'errors');
  console.log(Object.keys(errors).length, 'Object.keys(errors)');
  console.log(state, 'data');
  console.log(carCondition, 'p carCondition');
  // get post id from params
  var handleInputChange = function handleInputChange(event) {
    var _event$target = event.target,
      name = _event$target.name,
      value = _event$target.value;

    // Allow numbers and commas, and strip out invalid characters
    var numericValue = value.replace(/[^0-9,]/g, '');

    // Check if the input is valid and parse it
    var parsedValue = parseFloat(numericValue.replace(/,/g, '')); // Remove commas for parsing

    // Validate empty and negative values
    if (numericValue === '' || parsedValue < 0) {
      setState(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), {}, _defineProperty({}, name, 0));
      });
      return;
    }
    onInteraction({
      field: name === 'down_payment' ? 'first_payment' : name
    });
    // Validate down_payment and last_payment
    if (name === 'down_payment' && parsedValue > state.max_down_payment || name === 'last_payment' && parsedValue > state.max_last_payment) {
      updateErrors(_objectSpread(_objectSpread({}, errors), {}, _defineProperty({}, name, t("\u0627\u0644\u062D\u062F \u0627\u0644\u0623\u0642\u0635\u0649 \u0644\u0644\u062F\u0641\u0639\u0629 \u0627\u0644\u0623\u0648\u0644\u0649  ".concat(state.max_down_payment, "  \u0631\u064A\u0627\u0644"), {
        ns: 'web_common'
      }))));
      return;
    } else {
      // Clear the error if the value is valid
      var _ = errors[name],
        rest = _objectWithoutProperties(errors, [name].map(_toPropertyKey));
      updateErrors(rest);
    }

    // Only update state if the value is valid
    setState(function (prevState) {
      return _objectSpread(_objectSpread({}, prevState), {}, _defineProperty({}, name, parsedValue));
    });
  };
  var handleYearChange = function handleYearChange(year) {
    setState(function (prevState) {
      return _objectSpread(_objectSpread({}, prevState), {}, {
        period: year * 12
      });
    });
    onInteraction({
      field: "financing_period"
    });
  };
  var handleFinanceRequest = function handleFinanceRequest() {
    setButtonLoading(true);

    // set data to the session storage
    sessionStorage.setItem("installment-calculator-".concat(postId), JSON.stringify({
      down_payment: state.down_payment,
      last_payment: state.last_payment,
      period: state.period,
      monthly_installment: state.monthly_installment
    }));
    setButtonLoading(false);
    onClose();
    console.log('after closing');
    navigate("/finance-apply-free/".concat(postId, "?financestep=1"));
  };
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: stl.calculatorViewContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.monthlyPaymentBox
  }, /*#__PURE__*/React.createElement("p", {
    className: stl.monthlyPaymentBoxTitle
  }, t('قيمة القسط الشهري', {
    ns: 'web_common'
  })), /*#__PURE__*/React.createElement("p", {
    className: stl.monthlyPaymentValueBox
  }, /*#__PURE__*/React.createElement("span", {
    className: stl.monthlyPaymentPrice
  }, formatNumberWithCommas(state.monthly_installment)), /*#__PURE__*/React.createElement("span", {
    className: stl.monthlyPriceUnit
  }, /*#__PURE__*/React.createElement("span", null, t('ريال', {
    ns: "web_common"
  })), /*#__PURE__*/React.createElement("span", null, t('شهرياً', {
    ns: "web_common"
  })))), /*#__PURE__*/React.createElement("p", {
    className: stl.monthlyPaymentBoxNote
  }, carCondition !== 'used' ? t("هذا السعر تقديري ويتضمن التأمين الشامل للسيارة", {
    ns: "web_checkout_finance"
  }) : t("هذا السعر تقديري ولا يتضمن التأمين الشامل للسيارة", {
    ns: "web_checkout_finance"
  })), /*#__PURE__*/React.createElement("div", {
    className: stl.paymentBoxDivider
  }), /*#__PURE__*/React.createElement("div", {
    className: stl.monthlyPaymentBoxFoter
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.totalFinanceBox
  }, /*#__PURE__*/React.createElement("p", {
    className: stl.totalFinanceText
  }, t('مبلغ التمويل الإجمالي', {
    ns: 'web_common'
  })), /*#__PURE__*/React.createElement("p", {
    className: stl.totalFinanceNumber
  }, /*#__PURE__*/React.createElement("span", null, formatNumberWithCommas(state === null || state === void 0 ? void 0 : state.total_financing_amount_without_down_payment)), /*#__PURE__*/React.createElement("span", {
    className: stl.totalFinanceUnit
  }, t('ريال', {
    ts: "web_common"
  })))), /*#__PURE__*/React.createElement("p", {
    className: stl.monthlyPaymentNote
  }, t('عبارة عن اجمالي قيمة التمويل بدون دفعة اولى', {
    ns: 'web_common'
  })))), /*#__PURE__*/React.createElement("div", {
    className: stl.alertBox
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.alertRightSide
  }, /*#__PURE__*/React.createElement("img", {
    src: "/assets/images/info-icon-gray-dark.svg",
    alt: "",
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("span", {
    className: stl.alertText
  }, t('قد تكون غير مؤهل لهذا العرض التمويلي', {
    ns: 'web_common'
  }))), /*#__PURE__*/React.createElement("p", {
    className: stl.financingTerms,
    onClick: function onClick() {
      return goToScreen(2);
    }
  }, t('شروط التمويل', {
    ns: 'web_common'
  }))), /*#__PURE__*/React.createElement("div", {
    className: stl.financePeriodBox
  }, /*#__PURE__*/React.createElement("p", {
    className: stl.financePeriodTitle
  }, t('مدة التمويل بالسنوات', {
    ns: 'web_common'
  })), /*#__PURE__*/React.createElement("div", {
    className: stl.financePeriodYearsBox
  }, Array.from({
    length: state.years
  }, function (_, i) {
    return /*#__PURE__*/React.createElement("div", {
      className: [stl.financePeriodYear, state.period / 12 === i + 1 ? stl.financePeriodYearActive : ''].join(' '),
      key: "financePeriodYear-".concat(i),
      onClick: function onClick() {
        return handleYearChange(i + 1);
      }
    }, /*#__PURE__*/React.createElement("span", {
      className: stl.financePeriodYearValue
    }, i + 1), /*#__PURE__*/React.createElement("span", {
      className: stl.financePeriodYearUnit
    }, getArabicYearWord(i + 1, t)));
  }))), /*#__PURE__*/React.createElement("div", {
    className: stl.InputControl
  }, /*#__PURE__*/React.createElement(Input, {
    extraInfo: t("ريال", {
      ns: "web_checkout_finance"
    }),
    className: [stl.formStyle, errors.down_payment ? stl.inputError : ""].join(" "),
    name: "down_payment",
    label: t("الدفعة الاولى", {
      ns: "web_checkout_finance"
    }),
    type: "string",
    onFocus: function onFocus() {
      if (errors !== null && errors !== void 0 && errors.down_payment) {
        var down_payment = errors.down_payment,
          rest = _objectWithoutProperties(errors, _excluded);
        updateErrors(rest);
      }
    },
    onBlur: function onBlur() {
      if (errors !== null && errors !== void 0 && errors.down_payment) {
        var down_payment = errors.down_payment,
          rest = _objectWithoutProperties(errors, _excluded2);
        updateErrors(rest);
      }
    },
    min: 0,
    max: 7500
    // @ts-ignore
    ,
    onChange: handleInputChange,
    value: formatNumberWithCommas((_state$down_payment = state.down_payment) !== null && _state$down_payment !== void 0 ? _state$down_payment : 0)
  }), /*#__PURE__*/React.createElement("span", {
    className: [stl.inputInfo, errors.down_payment ? stl.inputError : ""].join(" ")
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", null, t("\u0627\u0644\u062F\u0641\u0639\u0629 \u0627\u0644\u0627\u0648\u0644\u0649 \u064A\u062C\u0628 \u0627\u0646 \u0644\u0627 \u062A\u0632\u064A\u062F \u0639\u0646: ", {
    ns: "web_checkout_finance"
  })), /*#__PURE__*/React.createElement("span", {
    className: stl.inputInfoMax
  }, formatNumberWithCommas(state.max_down_payment), " "), /*#__PURE__*/React.createElement("span", null, t('ريال', {
    ns: "web_checkout_finance"
  }))))), /*#__PURE__*/React.createElement("div", {
    className: stl.inputsWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.InputControl
  }, /*#__PURE__*/React.createElement(Input, {
    extraInfo: t("ريال", {
      ns: "web_checkout_finance"
    }),
    className: [stl.formStyle, errors.last_payment ? stl.inputError : ""].join(" "),
    name: "last_payment",
    min: 0,
    max: 7500,
    label: t("الدفعة الاخيرة", {
      ns: "web_checkout_finance"
    }),
    type: "string",
    onFocus: function onFocus() {
      if (errors !== null && errors !== void 0 && errors.last_payment) {
        var last_payment = errors.last_payment,
          rest = _objectWithoutProperties(errors, _excluded3);
        updateErrors(rest);
      }
    },
    onBlur: function onBlur() {
      if (errors !== null && errors !== void 0 && errors.last_payment) {
        var last_payment = errors.last_payment,
          rest = _objectWithoutProperties(errors, _excluded4);
        updateErrors(rest);
      }
    }
    // @ts-ignore
    ,
    onChange: handleInputChange,
    value: formatNumberWithCommas((_state$last_payment = state.last_payment) !== null && _state$last_payment !== void 0 ? _state$last_payment : 0)
  }), /*#__PURE__*/React.createElement("span", {
    className: [stl.inputInfo, errors.last_payment ? stl.inputError : ""].join(" ")
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", null, t("\u0627\u0644\u062F\u0641\u0639\u0629 \u0627\u0644\u0627\u062E\u064A\u0631\u0629 \u064A\u062C\u0628 \u0627\u0646 \u0644\u0627 \u062A\u0632\u064A\u062F \u0639\u0646: ", {
    ns: "web_checkout_finance"
  })), /*#__PURE__*/React.createElement("span", {
    className: stl.inputInfoMax
  }, formatNumberWithCommas(state === null || state === void 0 ? void 0 : state.max_last_payment), " "), /*#__PURE__*/React.createElement("span", null, t('ريال', {
    ns: "web_checkout_finance"
  })))))), /*#__PURE__*/React.createElement("div", {
    className: stl.footerDivider
  }), /*#__PURE__*/React.createElement("div", {
    className: stl.ctaWrapper
  }, /*#__PURE__*/React.createElement("button", {
    className: stl.financeCta,
    onClick: function onClick() {
      return !buttonLoading && handleFinanceRequest();
    },
    disabled: Object.keys(errors).length > 0
  }, buttonLoading ? /*#__PURE__*/React.createElement("span", {
    className: stl.loader
  }) : /*#__PURE__*/React.createElement(React.Fragment, null, t('موّل سيارتك الآن', {
    ns: 'web_common'
  }))))));
};
var InstallmentCalculatorView = function InstallmentCalculatorView(_ref2) {
  var carCondition = _ref2.carCondition,
    cashPrice = _ref2.cashPrice,
    onClose = _ref2.onClose,
    onInteraction = _ref2.onInteraction;
  return /*#__PURE__*/React.createElement(InstallmentCalculatorProvider, {
    carCondition: carCondition,
    cashPrice: cashPrice
  }, /*#__PURE__*/React.createElement(InstallmentCalculator, {
    onClose: onClose,
    carCondition: carCondition,
    onInteraction: onInteraction
  }));
};
export default InstallmentCalculatorView;